import React, { useEffect, useState } from "react";
import { getLeagues } from "../../api/leagues";
import LeagueFilters from "../../components/Leagues/LeagueFilters";
import LeagueList from "../../components/Leagues/LeagueList";
import { AlertUserSessionExpiredToken } from "../../components/AlertUserSessionExpiredToken";
import { toastError } from "../../helpers/notificationHelpers";

function LeaguesPage() {
	const [filters, setFilters] = useState({ activesOnly: false });
	const [isLoading, setIsLoading] = useState(false);
	const [leagues, setLeagues] = useState([]);

	useEffect(() => {
		const loadLeagues = async () => {
			setIsLoading(true);

			try {
				const response = await getLeagues(filters);

				if (!response || response.status !== 200) {
					toastError(
						response?.data?.Errors?.[0] || "Ha ocurrido un error cargando las ligas."
					);
					setLeagues([]);
					return;
				}

				setLeagues(response.data?.Result || []);
			} catch (error) {
				toastError("Ha ocurrido un error cargando las ligas.");
				setLeagues([]);
			} finally {
				setIsLoading(false);
			}
		};

		loadLeagues();
	}, [filters]);

	return (
		<React.Fragment>
			<div className='container py-4'>
				<AlertUserSessionExpiredToken />
				<div className='row mb-4'>
					<div className='col-12'>
						<h4>Ligas</h4>
						<p className='mb-0'>
							Gestiona las ligas o torneos disponibles en el sistema.
						</p>
					</div>
				</div>
				<LeagueFilters filters={filters} onChange={setFilters} />
				<div className='row'>
					<div className='col-12'>
						<div className='d-flex justify-content-between align-items-center mb-3'>
							<strong>Total: {leagues.length}</strong>
							{isLoading && <span>Cargando...</span>}
						</div>
						{!isLoading && <LeagueList leagues={leagues} />}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export { LeaguesPage };